import React from "react";
import classNames from "classnames";

const Label = ({ content, labelFor, classes, imp }) => {
  return (
    <label htmlFor={labelFor} className={classNames("font-poppins", classes)}>
      {imp ? (
        <>
          {content} <sup className="text-secondary">*</sup>
        </>
      ) : (
        <>{content}</>
      )}
    </label>
  );
};

export default Label;
